<script>
export default {
  name: 'PartnerApiIntegrationGuide'
}
</script>

<template>
  <div class="partner-api-guide">
    <div class="guide-heading">API Key 발급과 오더 등록 테스트</div>
    <p class="guide-copy">
      외부 파트너가 AONE API를 호출하려면 파트너별 API Key가 필요합니다.
      원문 키는 발급 직후 한 번만 확인할 수 있으며, 파트너는 인증 확인 후 오더 등록 API를 테스트할 수 있습니다.
    </p>

    <div class="row q-col-gutter-md">
      <div class="col-12 col-md-4">
        <div class="guide-card">
          <div class="guide-card__title">1. 파트너 확인</div>
          <div class="guide-card__copy">
            API를 사용할 파트너를 먼저 선택합니다. 키는 선택된 파트너에만 연결됩니다.
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="guide-card">
          <div class="guide-card__title">2. 키 발급</div>
          <div class="guide-card__copy">
            키 이름은 파트너나 사용 목적을 알 수 있게 입력합니다. 예: partner-order-prod, partner-test.
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="guide-card">
          <div class="guide-card__title">3. 테스트 진행</div>
          <div class="guide-card__copy">
            인증 확인 API와 오더 등록 API 경로를 함께 전달합니다. 같은 외부 주문번호는 중복 등록되지 않습니다.
          </div>
        </div>
      </div>
    </div>

    <div class="guide-subheading">파트너에게 전달할 내용</div>
    <ol class="guide-steps">
      <li>
        <span>API Key</span>
        <small>관리자 화면에서 발급한 원문 키를 별도 보안 채널로 전달합니다.</small>
      </li>
      <li>
        <span>인증 확인 API</span>
        <small>먼저 인증 확인 API로 키가 정상 동작하는지 검증하게 합니다.</small>
      </li>
      <li>
        <span>오더 등록 API</span>
        <small><code>POST /api/external/partner/v1/orders</code>로 테스트 주문을 등록합니다.</small>
      </li>
      <li>
        <span>요청 헤더</span>
        <small><code>X-AONE-API-KEY: &lt;API_KEY&gt;</code> 또는 <code>Authorization: Bearer &lt;API_KEY&gt;</code>를 사용합니다.</small>
      </li>
      <li>
        <span>파트너 API 문서</span>
        <small><code>docs/partner-api/partner-api-guide.md</code> 파일을 전달용 원본으로 사용합니다.</small>
      </li>
    </ol>

    <q-banner rounded class="guide-warning q-mt-md">
      <template #avatar>
        <q-icon name="security" color="orange-8" />
      </template>
      DB에는 원문 API Key가 저장되지 않습니다. 키를 분실하면 기존 키를 비활성화하고 새로 발급해야 합니다.
    </q-banner>
  </div>
</template>

<style scoped>
.guide-heading {
  font-size: 22px;
  font-weight: 800;
  color: #1f2a44;
}

.guide-copy {
  margin: 8px 0 18px;
  color: #5f6b7a;
  line-height: 1.6;
}

.guide-card {
  height: 100%;
  padding: 18px;
  border-radius: 16px;
  background: #f7f9fc;
  border: 1px solid #e2e8f0;
}

.guide-card__title,
.guide-subheading {
  font-weight: 800;
  color: #1f2a44;
}

.guide-card__copy,
.guide-steps small {
  color: #607089;
  line-height: 1.55;
}

.guide-subheading {
  margin-top: 24px;
  margin-bottom: 10px;
  font-size: 16px;
}

.guide-steps {
  margin: 0;
  padding-left: 20px;
}

.guide-steps li {
  margin-bottom: 12px;
}

.guide-steps li > span {
  display: block;
  font-weight: 800;
  color: #24324a;
}

.guide-steps code {
  padding: 2px 5px;
  border-radius: 5px;
  background: #eef2f7;
  color: #1f2a44;
}

.guide-warning {
  background: #fff8e1;
  color: #6d4c00;
}
</style>
